import(/* webpackMode: "eager" */ "/vercel/path0/components/analytics/TrackedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecipeEmailCta"] */ "/vercel/path0/components/recipe/RecipeEmailCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareBar"] */ "/vercel/path0/components/shared/ShareBar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
